import { render, staticRenderFns } from "./SearchDirection.vue?vue&type=template&id=b8c0318c"
import script from "./SearchDirection.vue?vue&type=script&lang=js"
export * from "./SearchDirection.vue?vue&type=script&lang=js"
import style0 from "./SearchDirection.vue?vue&type=style&index=0&id=b8c0318c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports